<template>
  <div class="ren-decoration-cp ren-decoration-cp-video" :class="{ 'is-empty': !videoUrl }" :style="frameStyle">
    <video
      v-if="videoUrl"
      :src="videoUrl"
      :poster="posterUrl || undefined"
      :controls="controls"
      :loop="loop"
      preload="metadata"
    />
    <div v-else>
      <b>播放</b>
      <span>视频内容</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue } from '../../../previews/preview-helpers'
import { widgetMediaUrl } from '../../media'
import type { WidgetPreviewProps } from '../../types'
import { widgetHasFixedHeight } from '../../widget-style'
import { WIDGET_STYLE_FALLBACKS } from '../../widget-style-defaults'

const props = defineProps<WidgetPreviewProps>()

const videoUrl = computed(() =>
  widgetMediaUrl(props.component.props?.videoUrl ?? props.component.props?.url)
)
const posterUrl = computed(() => widgetMediaUrl(props.component.props?.posterUrl))
const controls = computed(() => booleanValue(props.component.props?.controls, true))
const loop = computed(() => booleanValue(props.component.props?.loop, false))
const frameStyle = computed(() =>
  widgetHasFixedHeight(props.component.style)
    ? undefined
    : { minHeight: `${WIDGET_STYLE_FALLBACKS.mediaHeight}px` },
)
</script>

<style scoped>
.ren-decoration-cp-video {
  display: grid;
  place-items: center;
  overflow: hidden;
  background: var(--ren-theme-background);
  color: var(--ren-theme-muted);
}

.ren-decoration-cp-video video {
  display: block;
  width: 100%;
  height: auto;
}

.ren-decoration-cp-video div {
  display: grid;
  place-items: center;
  gap: 8px;
}

.ren-decoration-cp-video b {
  color: var(--ren-theme-primary);
}
</style>
